
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.818 15.508a3.001 3.001 0 012.365 0l3.999 1.714A3.001 3.001 0 0128 19.98v9.022a3 3 0 01-3 3H3a3 3 0 01-3-3V19.32a2 2 0 011.212-1.839l4.606-1.973a3 3 0 012.364 0l5.424 2.324c.252.107.537.108.789 0l5.423-2.325zM19 0l9 8v4.93a1 1 0 01-1.423.906l-5.201-2.427a2 2 0 00-1.74.024l-5.653 2.825a1 1 0 01-.95-.03l-4.629-2.7a2 2 0 00-1.853-.086l-5.128 2.394A1 1 0 010 12.93V3a3 3 0 013-3h16z","fill":"#C4C4C4"}}),_c('path',{attrs:{"d":"M19 6V0l9 8h-7a2 2 0 01-2-2z","fill":"#161616","fill-opacity":".24"}})])
          )
        }
      }
    